export type { Env } from './env';
export {
    getEnv,
    getIsPageServerSideRendered,
    EnvType,
    getIsMultiHCEnabled,
    getIsHCCustomizationEnabled,
    getJsmAIConfigEnabled,
} from './env';
